import { render, staticRenderFns } from "./DiscussionThreadFront.vue?vue&type=template&id=e06cb1f2"
import script from "./DiscussionThreadFront.vue?vue&type=script&lang=js"
export * from "./DiscussionThreadFront.vue?vue&type=script&lang=js"
import style0 from "./DiscussionThreadFront.vue?vue&type=style&index=0&id=e06cb1f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports